// 
// Javascript to hide accordions if empty on certain pages
//
document.addEventListener('DOMContentLoaded', function() {
  // Get all elements with class 'template-product'
  var templateProducts = document.querySelectorAll('.template-product');
  
  // Loop through each 'template-product' element
  templateProducts.forEach(function(templateProduct) {
    // Call the function for each accordion content element within the current 'template-product'
    hideParentIfNoPTags(templateProduct, '.accordion__content');
  });
  
  // Function to hide the parent element if it doesn't contain <p> tags
  function hideParentIfNoPTags(templateProduct, elementClass) {
    var accordionContents = templateProduct.querySelectorAll(elementClass);
    
    accordionContents.forEach(function(accordionContent) {
      var pTags = accordionContent.querySelectorAll('p');
      var imgTags = accordionContent.querySelectorAll('img');

      // Check if there are no <p> tags within the accordion content
      if (pTags.length === 0 && imgTags.length === 0) {
        var accordionInner = findParentWithClass(accordionContent, 'accordion__inner');
        if (accordionInner) {
          accordionInner.style.display = 'none';
        }
      }
    });
  }

  // Function to find the closest parent element with a specified class
  function findParentWithClass(element, className) {
    while ((element = element.parentElement)) {
      if (element.classList.contains(className)) {
        return element;
      }
    }
    return null;
  }
});


//
// Hide empty callout boxes
//

// Get all elements with class ".product__callouts-items[data-with-box=true]"
const blockCallouts = document.querySelectorAll('.product__callouts-items[data-with-box=true]');

// Loop through each block of callouts
blockCallouts.forEach((block) => {
  // Get all child elements with class "product__callouts-item" within the current block
  const calloutItems = block.querySelectorAll('.product__callouts-item');
  let allEmpty = true; // Assume all are empty initially

  // Loop through each "product__callouts-item" within the block
  calloutItems.forEach((item) => {
    // Find the <p> element within the current item
    const paragraph = item.querySelector('p');

    // Check if the <p> element exists and contains a <strong> tag
    if (paragraph) {
      const strongElement = paragraph.querySelector('strong');

      // Check if the <strong> tag exists and if it has a sibling
      if (strongElement && strongElement.nextSibling) {
        const textAfterStrong = strongElement.nextSibling;

        // Check if there is content after the <strong> tag
        if (textAfterStrong.nodeType === Node.TEXT_NODE && textAfterStrong.textContent.trim().length > 0) {
          // If there is content, set allEmpty to false
          allEmpty = false;
        }
      }
    }
  });

  // If all .product__callouts-item elements within the block have empty content, hide the block
  if (allEmpty) {
    block.style.display = 'none';
  }
});



document.addEventListener("DOMContentLoaded", function() {
  // Function to check and add class for each instance
  function checkAndAddClass() {
    const spanElements = document.querySelectorAll('[data-js-cart-count]');

    spanElements.forEach(function(spanElement) {
      const number = parseInt(spanElement.textContent);

      if (number > 0) {
        spanElement.classList.add('colour-change');
      } else {
        spanElement.classList.remove('colour-change');
      }
    });
  }

  // Call the function initially
  checkAndAddClass();

  // Set up a setInterval to check every second
  setInterval(checkAndAddClass, 1000);
});



// try to ensure that videos autoplay if they become visible

document.addEventListener("DOMContentLoaded", function() {


  let mediaGallery = document.querySelectorAll(".product__media-item");

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver( function(mutationList){

    for (const mutation of mutationList) {

      if (mutation.type === "attributes") {

        // if old value had hidden in it and new value doesnt -- find the video and play it
        if ( (mutation.oldValue.indexOf('hidden') !== -1 ) && (mutation.target.className.indexOf('hidden') === -1 ) ){

          let videoEl = mutation.target.querySelector("video");

          if(videoEl){
            // console.log( 'PLAYING --- ', videoEl  );
            videoEl.play();
          }
        }

        // or if old value had swiper-slide-visible in it and new value doesnt -- find the video and play it
        if ( (mutation.oldValue.indexOf('swiper-slide-visible') === -1 ) && (mutation.target.className.indexOf('swiper-slide-visible') !== -1 ) ){

          let videoEl = mutation.target.querySelector("video");

          if(videoEl){
            videoEl.play();
          }
        }
        
      }
    }
  });


  const config = { attributes: true, attributeFilter: ['class'], attributeOldValue : true };

  mediaGallery.forEach( function( item ){
      observer.observe(item, config);
  });

});


// fix bug related to users going back to PDP and not seeing correct count in basket, by refreshing the side/mini cart
document.addEventListener("DOMContentLoaded", function() {

  // if this is the PDP - refresh the minicart
  if( document.body.classList.contains('template-product')){

    document.dispatchEvent(new CustomEvent( 'apps:product-added-to-cart' ));

  }

} );


// fix bug related to users going back to PDP and not seeing correct count in basket, by refreshing the side/mini cart
document.addEventListener("DOMContentLoaded", function() {

  
    
  // This event fires whenever the quick cart is opened.
  // This event is exposed when the ajax cart is enabled.
  document.addEventListener("quick-cart:close", function () {
    console.log("Quick cart closed .....");
  });

} );



// adjust the quantity increment decrement buttons to use the increments set in pricelists

document.addEventListener("DOMContentLoaded", function() {


  // add event listener to quantity dropdown
  document.querySelectorAll('.product__meta select.quantity-input__input' ).forEach( function(el){

    let hiddenQuantityInput = el.closest('.product__meta').querySelector('.product-form__input--quantity');
    // assign the inital value to the hidden  quantity field

    hiddenQuantityInput.value = el.dataset.incrementQuantity;

    el.addEventListener('change', function(evt){

      hiddenQuantityInput.value = el.value;

    });

  });
  

} );
